/** @jsx jsx */
import { ClassNames, jsx } from '@emotion/react';
import ButtonAnchor from 'components/ButtonAnchor';
import Container from 'components/Container';
import React from 'react';
import HtmlParser from 'react-html-parser';
import { Application } from 'types/Application';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ApplicationDetailInfoProps extends React.HTMLAttributes<HTMLDivElement> {
  application: Application;
}

const ApplicationDetailInfo = React.forwardRef<HTMLDivElement, ApplicationDetailInfoProps>(({ application }, ref) => {
  const { manufacturer, buttons1 } = application;

  return (
    <ClassNames>
      {({ theme }) => (
        <Container maxWidth='lg'>
          <div
            ref={ref}
            css={{
              '@media(min-width: 960px)': {
                padding: theme.spacing(4, 2),
              },
              alignItems: 'stretch',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              padding: theme.spacing(4, 0),
              width: '100%',
            }}
          >
            <div css={{ display: 'flex', flexDirection: 'column' }}>
              <div
                css={{
                  '@media(min-width: 960px)': {
                    alignItems: 'flex-start',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  },
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div
                  css={{
                    ...theme.typography.body1,
                    '&, & > p': {
                      marginBottom: theme.spacing(2),
                    },
                    '@media(min-width: 960px)': {
                      fontSize: 16,
                      maxWidth: '75%',
                    },
                    fontSize: 13,
                  }}
                >
                  {HtmlParser(application.description)}
                </div>
                <div>
                  <img src={manufacturer?.logo} alt={manufacturer?.title} css={{ maxWidth: 250 }} />
                </div>
              </div>
              <div
                css={{
                  '& > a': { margin: theme.spacing(2, 2, 2, 0) },
                  '@media(min-width: 600px)': {
                    '& > a': { margin: theme.spacing(2, 4, 2, 0) },
                  },
                  // '@media(min-width: 960px)': {
                  //   padding: theme.spacing(4),
                  // },
                  alignItems: 'center',
                  // alignSelf: 'flex-start',
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'left',
                }}
              >
                {buttons1.map(({ href, text }, idx) => (
                  <ButtonAnchor key={idx.toString()} href={href} css={{ alignSelf: 'flex-start' }}>
                    {text}
                  </ButtonAnchor>
                ))}
              </div>
            </div>
          </div>
        </Container>
      )}
    </ClassNames>
  );
});

export default ApplicationDetailInfo;
